module.exports = __webpack_public_path__ + "static/google-play-store-badge-ca501b4e8f8b770637b8eda34a01a328.svg";